import { useStytchB2BClient } from '@stytch/react/b2b'
import useMutation, {
  UseMutationOptions,
} from '@/service-library/core-hooks/useMutation'
import { getRedirectUrl } from '@/utils/auth'

type InviteMemberParams = {
  email_address: string
}

export function useInviteMember(
  options?: UseMutationOptions<void, unknown, InviteMemberParams>,
) {
  const stytch = useStytchB2BClient()

  const mutation = useMutation({
    mutationFn: async ({ email_address }: InviteMemberParams) => {
      await stytch.magicLinks.email.invite({
        email_address,
        invite_redirect_url: getRedirectUrl(),
      })
    },
    ...options,
  })

  return {
    ...mutation,
    inviteMember: mutation.mutateAsync,
  }
}
